import { createContext, useContext } from 'react';

/** Mobile drawer state for shell; game frame mounts its own menu button via this context. */
export const ShellSidebarContext = createContext(null);

export function useShellSidebar() {
  return useContext(ShellSidebarContext);
}
